export const bot = {
  modal: {
    // La bandeja ya no es solo de WhatsApp: reúne WhatsApp, Conserje web y OTA.
    title: "Bandeja de mensajes",
    subtitle: "WhatsApp, Conserje web y OTA en un solo sitio",
  },

  channels: {
    all: "Todos",
    whatsapp: "WhatsApp",
    web: "Web",
    ota: "OTA",
  },

  empty: {
    title: "No hay mensajes nuevos",
    description: "Cuando recibas nuevos mensajes del bot aparecerán aquí",
  },

  buttons: {
    markAll: "Marcar todas como leídas",
    goToChat: "Configurar Agente IA ✨",
    archive: "Archivar conversación",
  },

  actions: {
    replyWhatsApp: "Responder en WhatsApp",
  },

  time: {
    now: "Ahora",
    minuteSuffix: "m",
    hourSuffix: "h",
    daySuffix: "d",
    today: "Hoy",
    yesterday: "Ayer",
  },

  questions: {
    searchPlaceholder: "Buscar preguntas...",
    answered: "Respondida",
    noAnswer: "Sin responder",
    withImage: "Con imagen",
    empty: "No se encontraron preguntas",
    confirmDelete: "¿Estás seguro de que quieres eliminar esta pregunta?",
  },

  answer: {
    assistantResponse: "Respuesta del asistente",
    attachedImageOptional: "Imagen adjunta (opcional)",
    uploadImage: "Subir imagen",
    clickToSelect: "Click para seleccionar una imagen",
    changeImage: "Cambiar imagen",
    imagePreviewAlt: "Vista previa de la imagen",
    defaultImageName: "imagen.jpg",
  },

  phone: {
    online: "en línea",
    today: "Hoy",
    exampleQuestion: "Pregunta de ejemplo",
    writeAnswerPlaceholder: "Escribe una respuesta para esta pregunta...",
    writeMessagePlaceholder: "Escribe un mensaje...",
    answerImageAlt: "Imagen de respuesta",
    confirmDeleteImage: "¿Eliminar imagen?",
    imageDeletedSuccess: "Imagen eliminada correctamente.",
    virtualAssistant: "Asistente Virtual",
  },

  search: {
    placeholder: "Buscar por nombre, teléfono o código de reserva...",
    noResultsTitle: "No se encontraron conversaciones",
    noResultsDescription:
      "Prueba con otro nombre, teléfono o código de reserva.",
  },

  archive: {
    title: "Archivar conversación",
    message:
      "Si archivas esta conversación dejará de aparecer en esta lista. Podrás seguir viéndola desde la reserva asociada.",
    cancel: "Cancelar",
    confirm: "Archivar",
  },
};

export default bot;
